import {
  Backdrop,
  Box,
  Card,
  CardActionArea,
  CardContent,
  Container,
  Fade,
  Modal,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'

import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import { makeGetRequest } from 'utils/api'
import ClearIcon from '@mui/icons-material/Clear'
import { setSitePersonnaliser } from 'reduxLib/slices/userSlice'
import { useDispatch } from 'react-redux'
import AddIcon from '@mui/icons-material/Add'
import { makePostRequest } from 'utils/api'
import { setSiteUser } from 'reduxLib/slices/userSlice'
// import { NoBackpackSharp } from '@mui/icons-material'

// const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

function LandingPage() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const dispatch = useDispatch()
  const siteUser = useSelector((store) => store.user)
  // LAP-733 (GE022) — re-fetch Lifeapps whenever the UI language changes so
  // the localised Nom/SousTitre/Footer come back from the backend.
  // We also use t() to translate the small fixed list of group titles
  // (Finance / General / Social / Home / Administratif / Perso. / Earth / Pro.)
  // since those are categorical labels rather than per-row content.
  const { t, i18n: i18nInstance } = useTranslation('layout')
  // console.log(siteUser.user)
  // const app_group = '[{"name":"Finance","value":"Finances"}]'
  const page_daccueil = siteUser.user?.user_parameter?.page_daccueil

  const app_group = siteUser.user?.app_group
  const personnaliser = siteUser.user?.personnaliser || false
  const app_group_list = JSON.parse(app_group || '[]')

  const navigate = useNavigate()

  const [lifeApps, setLifeApps] = useState([])
  // const [templifeApps, setTempLifeApps] = useState([])
  const [lifeGroupe, setLifeGroupe] = useState([])
  const [lifeGroupeTemp, setLifeGroupeTemp] = useState([])

  const [eventCount, setEventCount] = useState(0)
  const [groupe, setGroupe] = useState('')
  // const [AccountBalance, setAccountBalance ] = useState(0)

  useEffect(() => {
    getAppData()
    // LAP-733 (GE022) — refetch on language switch.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18nInstance.language])
  useEffect(() => {
    if (lifeGroupe.length > 0) {
      if (page_daccueil === 'Tout') {
        setLifeGroupeTemp(lifeGroupe)
      } else {
        setLifeGroupeTemp([lifeGroupe[0]])
      }
    }
  }, [page_daccueil, lifeGroupe])

  const handleGroupe = (group) => {
    if (page_daccueil === 'Groupe') {
      setLifeGroupeTemp(lifeGroupe.filter((e) => e.nomgroupe === group))
    } else {
      document.getElementById(`app-${group}`).scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  const getAppData = async () => {
    try {
      // const { data } = await makeGetRequest('/api/base/Lifeapps/',{},true)
      const response = await makeGetRequest('/api/base/Lifeapps/', {}, true)
      if (!response) {
        console.error('No response from getAppData request')
        return
      }
      const { data, status } = response
      if (status === 401) {
        localStorage.removeItem('token')
        navigate('/login')
        return
      }
      const countResponse = await makeGetRequest(
        '/api/time/get-event-count/',
        {},
        true,
      )
      if (!countResponse) {
        console.error('No response from get-event-count request')
        return
      }
      const { data: count, status: check } = countResponse
      if (check === 401) {
        localStorage.removeItem('token')
        navigate('/login')
        return
      }

      if (count && count.count !== undefined) {
        setEventCount(count.count)
      }
      if (data) {
        setLifeApps([...data])

        let groupList = []
        let groups = []
        for (let r of data) {
          if (r.Groupe && r.display) {
            if (groups.indexOf(r.Groupe) === -1) {
              groups.push(r.Groupe)
              groupList.push({ nomgroupe: r.Groupe })
            }
          }
        }
        setLifeGroupe(groupList)
        if (page_daccueil === 'Tout') {
          setLifeGroupeTemp([groupList[0]])
        } else {
          setLifeGroupeTemp(groupList)
        }
      }
    } catch (error) {
      console.error('Error in getAppData:', error)
    }
  }
  const removeApp = async (id) => {
    const response = await makePostRequest('/api/base/remove-app/', { appid: id }, {}, true)
    if (response.status === 200) {
      getAppData()
    }
  }
  const handleChangeGroupe = async (element, groupe) => {
    // if (response.status === 200) {
    //   // getAppData()
    // }

    let user = { ...siteUser.user }
    let exist = app_group_list.filter((e) => e.name === groupe)
    let remain = app_group_list.filter((e) => e.name !== groupe)
    if (exist.length > 0) {
      exist[0].value = element.target.value
    } else {
      exist.push({ name: groupe, value: element.target.value })
    }
    let newList = [...remain, ...exist]

    user.app_group = JSON.stringify(newList)

    dispatch(setSiteUser(user))
    makePostRequest('/api/base/update-groupe/', { app_group: user.app_group || '[]' }, {}, true)
  }
  const getCustomGroupName = (name) => {
    // LAP-733 (GE022) — user override takes precedence (in personnaliser
    // mode the user can set their own label). Otherwise we fall back to
    // the localised label for the canonical group name; if the language
    // bundle has no entry, we return the canonical name unchanged.
    let groupName = app_group_list.filter((e) => e.name === name)
    if (groupName.length > 0) {
      return groupName[0].value
    }
    return t(`groups.${name}`, { defaultValue: name })
  }
  const Usedapps = (nomgroupe) => {
    return lifeApps.map((element, key) =>
      nomgroupe === element.Groupe && element.display ? (
        <Card
          className="iconpadd"
          key={key}
          sx={{
            position: 'relative',
            backgroundColor: theme.palette.appBar.main,
            minWidth: { xs: 140, md: 180 },
            minHeight: { xs: 140, md: 180 },
            margin: '5px',
            '&:hover': {
              backgroundImage: 'radial-gradient(#001b42,#00001d)',
            },
            width: isMobile ? '43%' : 'auto',
            pb: isMobile ? 2 : 0,
          }}
        >
          {personnaliser && (
            <Box display={'flex'} justifyContent={'end'}>
              <ClearIcon
                onClick={() => removeApp(element.id)}
                sx={{
                  color: 'white',
                  background: 'red',
                  borderRadius: 3,
                  cursor: 'pointer',
                  // position: 'absolute',
                  // right: 0,
                }}
              />
            </Box>
          )}
          <CardActionArea
            sx={{ height: '100%' }}
            onClick={() => {
              navigate(element.Lien)
              dispatch(setSitePersonnaliser(false))
            }}
          >
            <CardContent
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <Typography
                  fontSize={isMobile ? '.78rem' : '1.1rem'}
                  variant="subtitle1"
                  sx={{
                    paddingTop: '5px',
                    color: theme.palette.appBar.color,
                  }}
                >
                  {element.Nom}
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontSize={isMobile ? '.78rem' : '1rem'}
                  component="div"
                  sx={{
                    fontWeight: '400',
                    color: 'gray',
                    lineHeight: '1.5',
                  }}
                >
                  {element.SousTitre === '' ? <span>&nbsp;</span> : element.SousTitre}
                </Typography>
              </Box>
              <Box mt={5} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                <Box sx={{ float: 'left' }}>
                  {element.Icone && (
                    <img
                      alt="logo"
                      height={isMobile ? 40 : 50}
                      width={isMobile ? 40 : 50}
                      src={element.Icone}
                    />
                  )}
                </Box>
                <Box sx={{ float: 'right' }}>
                  <Typography
                    sx={{
                      fontSize: isMobile ? '0.85rem' : '1.2rem',
                      fontWeight: '400',
                      color: theme.palette.appBar.color,
                      lineHeight: '1.5',
                    }}
                  >
                    {element.Indicateur}
                  </Typography>

                  {element.Code === 'MC' && (
                    <Typography
                      sx={{
                        fontWeight: '400',
                        color: theme.palette.appBar.color,

                        lineHeight: '1.5',
                        fontSize: isMobile ? '0.85rem' : '1.2rem',
                      }}
                    >
                      {eventCount}
                    </Typography>
                  )}
                  {element.Footer && (
                    <Typography
                      sx={{
                        fontWeight: '400',
                        color: 'gray',
                        lineHeight: '1.5',
                        fontSize: isMobile ? '0.75rem' : '1.2rem',
                      }}
                    >
                      {element.Footer}
                    </Typography>
                  )}
                </Box>
              </Box>
            </CardContent>
          </CardActionArea>
        </Card>
      ) : null,
    )
  }
  // const executeScroll = (e) =>  console.log(e.target.innerHTML);
  // const executeScroll = (e) =>  document.getElementById(e.target.innerHTML).scrollIntoView({behavior: "smooth", block: "start"});
  const LaunchPadgroupe =
    lifeGroupeTemp.length > 0 &&
    lifeGroupeTemp.map((element, key) => (
      <React.Fragment key={key}>
        <Typography
          key={key}
          color="white"
          variant="h6"
          p={1}
          mt={4}
          id={`app-${element?.nomgroupe}`}
        >
          {personnaliser ? (
            <>
              <input
                style={{ borderColor: 'red' }}
                onChange={(e) => handleChangeGroupe(e, element?.nomgroupe)}
                value={getCustomGroupName(element?.nomgroupe)}
                placeholder={element?.nomgroupe}
              />
            </>
          ) : (
            <>{getCustomGroupName(element?.nomgroupe)}</>
          )}
        </Typography>

        <Box display="flex" flexWrap="wrap">
          {' '}
          {Usedapps(element?.nomgroupe)}{' '}
          {personnaliser && (
            <Card
              key={key}
              sx={{
                position: 'relative',
                backgroundColor: theme.palette.appBar.main,
                minWidth: 180,
                minHeight: 180,
                margin: '5px',
                '&:hover': {
                  backgroundImage: 'radial-gradient(#001b42,#00001d)',
                },
              }}
            >
              <CardActionArea sx={{ height: '100%' }} onClick={() => setGroupe(element?.nomgroupe)}>
                <CardContent
                  sx={{
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <AddIcon sx={{ color: 'white', fontSize: '5.5rem' }} />
                </CardContent>
              </CardActionArea>
            </Card>
          )}
        </Box>
      </React.Fragment>
    ))

  return (
    <>
      <div style={{ minHeight: '100vh' }}>
        <Box bgcolor="#33416d">
          <Container>
            <Box display="flex" className="hell" overflow={'auto'}>
              {lifeGroupe &&
                lifeGroupe.map((element, key) => {
                  return (
                    <Typography
                      key={key}
                      sx={{ '&:hover': { cursor: 'pointer' } }}
                      color="white"
                      variant="subtitle1"
                      p={1}
                      onClick={() => handleGroupe(element.nomgroupe)}
                    >
                      {getCustomGroupName(element.nomgroupe)}
                    </Typography>
                  )
                })}
            </Box>
          </Container>
        </Box>
        <Container>
          {/* <Notifications /> */}
          {lifeGroupe.length > 0 && personnaliser && (
            <ClearIcon
              onClick={() => {
                dispatch(setSitePersonnaliser(false))
              }}
              sx={{
                color: 'white',
                background: 'red',
                borderRadius: 3,
                cursor: 'pointer',
                position: 'absolute',
                right: '10%',
              }}
            />
          )}

          {Usedapps('')}
          {LaunchPadgroupe && LaunchPadgroupe}
        </Container>
      </div>
      <AddAppModel group={groupe} setGroupe={setGroupe} getAppData={getAppData} />
    </>
  )
}

export default LandingPage

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 840,
  minWidth: 180,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
}
function AddAppModel({ group, setGroupe, getAppData }) {
  const [open, setOpen] = useState(false)
  const [appList, setAppList] = useState([])
  // const handleOpen = () => setOpen(true);
  const theme = useTheme()

  const handleClose = () => {
    setOpen(false)
    setGroupe('')
  }

  useEffect(() => {
    // setOpen(true)
    if (group !== '') {
      setOpen(true)
      addApp()
    } else {
      setOpen(false)
    }
  }, [group])

  const addApp = async () => {
    const response = await makePostRequest('/api/base/get-re-app/', { group: group }, {}, true)
    if (response.status === 200) {
      //
      setAppList(response.data)
    }
  }
  const handelAddApp = async (appId) => {
    const response = await makePostRequest('/api/base/add-app/', { appid: appId }, {}, true)
    if (response.status === 200) {
      //
      getAppData()
      handleClose()
    }
  }
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box display="flex" flexWrap="wrap">
              {appList.length < 1 && <Box>No more apps</Box>}
              {appList.map((element) => (
                <Card
                  key={element.id}
                  sx={{
                    position: 'relative',
                    backgroundColor: theme.palette.appBar.main,
                    minWidth: 180,
                    minHeight: 180,

                    margin: '5px',
                    '&:hover': {
                      backgroundImage: 'radial-gradient(#001b42,#00001d)',
                    },
                  }}
                >
                  <CardActionArea
                    onClick={() => {
                      handelAddApp(element.id)
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          paddingTop: '5px',
                          color: theme.palette.appBar.color,
                        }}
                      >
                        {element.Nom}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        component="div"
                        sx={{
                          fontWeight: '400',
                          color: 'gray',

                          lineHeight: '1.5',
                          // fontSize: "17px",
                        }}
                      >
                        {element.SousTitre === '' ? <span>&nbsp;</span> : element.SousTitre}
                      </Typography>
                      <Box sx={{ float: 'left', paddingTop: '40px' }}>
                        {' '}
                        {element.Icone && <img alt="logo" src={element.Icone} />}
                      </Box>
                      {element.Icone && (
                        <Box
                          sx={{
                            float: element.Code === 'MC' ? 'left' : 'right',
                            paddingTop: '40px',
                          }}
                        >
                          {/* <img alt="logo" src={element.Icone} style={{ width: '50px' }} /> */}
                        </Box>
                      )}
                      <Box sx={{ float: 'right', paddingTop: '40px' }}>
                        <div>
                          {/* {element.Indicateur && ( */}
                          <Typography
                            variant="h6"
                            component="div"
                            sx={{
                              fontWeight: '400',
                              color: theme.palette.appBar.color,
                              lineHeight: '1.5',
                              fontSize: '20px',
                            }}
                          >
                            {element.Indicateur}
                          </Typography>
                          {/* )} */}

                          {element.Footer && (
                            <Typography
                              variant="body2"
                              component="div"
                              sx={{
                                fontWeight: '400',
                                color: 'gray',
                                lineHeight: '1.5',
                                fontSize: '13px',
                              }}
                            >
                              {element.Footer}
                            </Typography>
                          )}
                        </div>
                      </Box>
                    </CardContent>
                  </CardActionArea>
                </Card>
              ))}
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  )
}
